import { BaseApi } from '@/helpers/base-api'

export default class CountriesApi extends BaseApi {
    constructor() {
        super('/api/v1/countries')
        this.errorMessage = 'There was an issue when trying to fetch the countries. If this error persists, please contact our support.'
    }

    public getAllCountries = (): Promise<string[]> => this.instance.get(``);
}